<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('cryptogramGenerator.edit.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('cryptogramGenerator.edit.title') }}
        </h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-cryptogram-new' }"
        >
          {{ $t('cryptogramGenerator.edit.button.add') }}
        </router-link>
      </d-col>
    </d-row>
    <cryptogram-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import CryptogramPage from '../components/CryptogramPage.vue';
import { _LOAD_MODEL_, MODEL } from '../components/CryptogramModel';

export default {
  name: 'puzzle-edit',
  components: {
    CryptogramPage,
  },
  computed: {
    cryptogram() {
      const { cryptogram } = this.$store.state.cryptogram;
      Events.$emit(_LOAD_MODEL_, cryptogram);
      if (cryptogram) {
        Events.$emit(_LOAD_MODEL_, cryptogram);
        return cryptogram;
      }
      return cloneDeep(MODEL);
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(['setToggle', 'getCryptogram']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getCryptogram(this.$route.params.puzzleId);
    }
  },
};
</script>
